// Opens a page's "Add / New" form when the URL carries ?new=1 (used by the
// Dashboard's "+ New" menu), then drops the parameter so a refresh or Back
// doesn't open it again.

import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export function useNewParam(open: () => void, enabled = true) {
  const loc = useLocation();
  const nav = useNavigate();
  useEffect(() => {
    if (!enabled || new URLSearchParams(loc.search).get('new') !== '1') return;
    open();
    nav(loc.pathname, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loc.search, enabled]);
}

/** Same idea for ?view=<id> (e.g. Receivable opening a sale's printable
 *  invoice on the Sales page). */
export function useViewParam(open: (id: string) => void, enabled = true) {
  const loc = useLocation();
  const nav = useNavigate();
  useEffect(() => {
    const id = new URLSearchParams(loc.search).get('view');
    if (!enabled || !id) return;
    open(id);
    nav(loc.pathname, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loc.search, enabled]);
}

/** ?item=<inventory id>: a stock page opened from the Inventory popup in a
 *  new tab starts with that stone already picked. */
export function useItemParam(open: (id: string) => void, enabled = true) {
  const loc = useLocation();
  const nav = useNavigate();
  useEffect(() => {
    const id = new URLSearchParams(loc.search).get('item');
    if (!enabled || !id) return;
    open(id);
    nav(loc.pathname, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loc.search, enabled]);
}
